export default "__VITE_ASSET__XHC_gofC__"